module.exports = __webpack_public_path__ + "img/Every Farm_alt_v2_text.6f27ac73.png";